exports = module.exports = require("../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ttSheAT_g2YpEqJJAxvi8{font-size:.8rem;text-align:right;margin:.25rem 0 0}.ttSheAT_g2YpEqJJAxvi8._1a_O_7ijyR7COw118eANGT{color:#ff6562}.ttSheAT_g2YpEqJJAxvi8._3KdHpBj4BzCqewDoxypDVg{color:#ffa91f}\n", ""]);

// exports
exports.locals = {
	"statusText": "ttSheAT_g2YpEqJJAxvi8",
	"statusTextError": "_1a_O_7ijyR7COw118eANGT",
	"statusTextWarning": "_3KdHpBj4BzCqewDoxypDVg"
};